<template>
  <div class="news-all">
    <div class="title">
      <span class="time">
        03.12
        <br />2019
      </span>
      <span class="tiel">美菜网成功举办供应商G50峰会，打造餐饮零售一条龙</span>
    </div>
    <div class="mat-content">
      <div class="tet-js">
        2018年末，美菜网于北京成功举办供应商G50峰会，在会议当中，各个领导人进行了讲话并说明，意在打造餐饮零售服务新现象。
        <br />
        <br />
      </div>
      <p align="center">
        <img src="@/assets/images/new-img/a011_2.png" width="640" />
      </p>
      <div class="tet-js" style="text-align: center">本次大会近千人规模，美菜网邀请了高瓴资本代表人来现场讲话。</div>
      <!-- <div class="title-bold"><span></span>20年里的朴实无华</div> -->
      <div class="tet-js">
        并邀请了益海嘉里，联合利华、新希望、蒙牛等诸多餐饮行业领袖、供应链大咖齐聚一堂，由美菜网高级副总裁王星致辞，探讨“共创餐饮零售无限场景”解决方案。
        <br />
        <br />
      </div>
      <p align="center">
        <img src="@/assets/images/new-img/a011_3.png" width="640" />
      </p>
      <div class="tet-js" style="text-align: center">
        美菜网高级副总裁王星致辞
        <br />
        <br />
      </div>
      <p align="center">
        <img src="@/assets/images/new-img/a011_4.png" width="640" />
      </p>
      <div class="tet-js" style="text-align: center">圆桌论坛</div>
      <div class="tet-js">
        发布新品牌Slogan“买菜卖菜上美菜”及品牌战略，推动供应链服务升级。
        <br />
        <br />美菜网市场副总裁李洪洋表示：“美菜在做一件民生大事，解决农业与食物链接的根本。
        <br />
        <br />
      </div>
      <p align="center">
        <img src="@/assets/images/new-img/a011_5.png" width="640" />
      </p>

      <div class="tet-js">
        未来，“上下用心，惟农是务”美菜将通过两端一链一平台模式，推动创造食物价值链与改变农业、农村、农民前行。”
        <br />
        <br />会中发布的新品牌战略上，美菜将建立四位一体的“无忧体系”，主打“品质无忧、价格无忧、选择无忧、服务无忧”。
        <br />
        <br />并建立绿色未来品牌生态，分别从产业、人才、文化、生态、组织五大方面。以此，通过美菜品牌升级，推动餐饮供应链服务的升级、增加餐饮行业发展的效率。
        <br />
        <br />发布1000计划，带动返乡就业。
        <br />
        <br />峰会现场，美菜网CEO刘传军在下午场的演讲中讲述了美菜未来战略，并正式发布了1000计划。
        <br />
        <br />刘传军表示，“美菜网一诞生，便自带扶贫性质，扶贫助农，是美菜血脉中的强基因。
        <br />
        <br />
      </div>

      <p align="center">
        <img src="@/assets/images/new-img/a011_6.png" width="640" />
      </p>
      <div class="tet-js">
        一直以来，美菜通过农产品上行，以产业化的模式，解决农民卖菜难的问题。
        <br />
        <br />未来美菜将建立以县政权为核心的业务经营体系。
        <br />
        <br />一方面，希望帮助我们的员工及那些抱负在县城，渴望实现创业梦，渴盼荣归故里的年轻人返乡创业。另一方面，美菜也希望将业务开拓至县级市场。”
        <br />
        <br />
      </div>

      <p align="center">
        <img src="@/assets/images/new-img/a011_7.png" width="640" />
      </p>
      <div class="tet-js" style="text-align: center">与供应链巨头共同推动产业链整合</div>
      <div class="tet-js">
        发布1000计划后，美菜网与益海嘉里、联合利华、新希望、广州聚农等行业巨头签署了新的战略协议。
        <br />
        <br />据悉，目前与美菜合作的供应商近5000家。未来，美菜将携手更多优质供应商共同推动产业链整合，以销定采;形成规模效应，降低商品进货成本，共同开创餐饮零售无限场景。
        <br />
        <br />
      </div>

      <p align="center">
        <img src="@/assets/images/new-img/a011_8.png" width="640" />
      </p>
      <div class="tet-js" style="text-align: center">在现场与供应商，一起合种云杉树</div>
      <div class="tet-js">
        目前，正在开发上下游供应链系统，跟供应商之间实现信息互通、数据共享，确保上下游的信息是一体化的，彻底改变传统零售商对于零售商在“费用、退货、账期”方面的积弊，打造稳定、健康、持续发展的互惠互利的良好关系。
        <br />
        <br />
      </div>

      <div class="title-bold">
        <span></span>首届G50峰会还宣布了——“最美菜公益爱心联盟”正式成立。
      </div>

      <div class="tet-js">
        四川鑫樽中恒商贸有限公司（雨橙生鲜）彭宇接过牌匾，成为最美菜公益爱心联盟的首位最美供应商。
        <br />
        <br />在他身后由100多位爱心供应商共同组成“最美菜公益爱心联盟”。
        <br />
        <br />
      </div>

      <p align="center">
        <img src="@/assets/images/new-img/a011_9.png" width="640" />
      </p>
      <div class="tet-js" style="text-align: center">雨橙生鲜彭宇和中国红十字基金会理事、美菜网副总裁李洪洋</div>
      <div class="tet-js">
        美菜网的供应商、合伙人将加入美菜公益扶贫事业，共同关注农村留守儿童，让农民摆脱卖菜难困境，靶向助力精准扶贫，实现美菜网“为八亿农民谋幸福”初心。
        <br />
        <br />
      </div>

      <p align="center">
        <img src="@/assets/images/new-img/a011_10.png" width="640" />
      </p>
      <div class="tet-js" style="text-align: center">G50联盟启动仪式</div>
      <div class="tet-js">
        刘传军表示，“面对餐饮零售化的巨大浪潮，美菜作为上游供应商与餐饮商家沟通的桥梁，将会与众多优秀供应商一起积极创新，提供符合餐饮商家需求的产品，不断开创出餐饮零售新场景。”
        <br />
        <br />在很多人心目中，美菜网已经不是简简单单的互联网餐饮的供应商这么简单了，在面对着美菜网的积极创新，投身于餐饮公益事业当中，很是富有社会责任感，将推动互联网餐饮行业迈向更好的明天。
        <br />
        <br />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "news-item"
};
</script>

<style lang="scss" scoped>
</style>
